module.exports = __webpack_public_path__ + "static/media/compare-small.838390dc.svg";